import { AxiosInstance } from 'axios';

type ReferrerReturnType = {
  code: String;
};
type CluesReferrerReturnType = {
  items: Array<{
    create_time: number;
    name: string;
    orga_name: string;
    phone: string;
  }>;
};

type GetSpeechListReturnType = Array<{ content: string }>;

export const recommendService = ({
  GateWayInstance,
  OfficialGateWayInstance,
}: {
  GateWayInstance: AxiosInstance;
  OfficialGateWayInstance: AxiosInstance;
}) => ({
  referrer(data: Record<string, any>) {
    return OfficialGateWayInstance.post<ReferrerReturnType>(`/referrer`, data);
  },
  cluesReferrer(phone?: string, code?: string) {
    const head: Record<string, any> = {};

    if (phone) head['X-Referrer-Phone'] = phone;
    if (code) head['X-Referrer-Phone-Code'] = code;

    return OfficialGateWayInstance.get<CluesReferrerReturnType>(`/referrer/clues`, {
      headers: head,
    });
  },
  getSpeechList() {
    return OfficialGateWayInstance.get<GetSpeechListReturnType>(`/referrer/pitches`);
  },
  sendCode(phone: string, valid: string) {
    return OfficialGateWayInstance.get(`/referrer/msgcode?phone=${phone}&valid=${valid}`);
  },
});

export type { ReferrerReturnType, CluesReferrerReturnType, GetSpeechListReturnType };
